import axios from "axios";
import { handleActions } from "redux-actions";

import Config from "config";
import { getHeaders } from "helpers/headers";
import { AnyAction } from "interfaces/action";
import { Announcement } from "interfaces/announcement";
import { Dispatch } from "interfaces/dispatch";
import { ThunkActionCreator } from "interfaces/thunk";
import { CREATE_ANNOUNCEMENT, DELETE_ANNOUNCEMENT } from "state/announcement";

// Action types
const FETCH_ANNOUNCEMENTS_REQUEST = "FETCH_ANNOUNCEMENTS_REQUEST";
const FETCH_ANNOUNCEMENTS = "FETCH_ANNOUNCEMENTS";
const FETCH_ANNOUNCEMENTS_FAILED = "FETCH_ANNOUNCEMENTS_FAILED";

const FETCH_MY_ANNOUNCEMENTS_REQUEST = "FETCH_MY_ANNOUNCEMENTS_REQUEST";
const FETCH_MY_ANNOUNCEMENTS = "FETCH_MY_ANNOUNCEMENTS";
const FETCH_MY_ANNOUNCEMENTS_FAILED = "FETCH_MY_ANNOUNCEMENTS_FAILED";

const CLEAR_ANNOUNCEMENTS = "CLEAR_ANNOUNCEMENTS";
const FETCH_MY_PROJECT_ANNOUNCEMENT_REQUEST = "FETCH_MY_PROJECT_ANNOUNCEMENT_REQUEST";
const FETCH_MY_PROJECT_ANNOUNCEMENT = "FETCH_MY_PROJECT_ANNOUNCEMENT";
const FETCH_MY_PROJECT_ANNOUNCEMENT_FAILED = "FETCH_MY_PROJECT_ANNOUNCEMENT_FAILED";

export {
  FETCH_ANNOUNCEMENTS_REQUEST,
  FETCH_ANNOUNCEMENTS,
  FETCH_ANNOUNCEMENTS_FAILED,
  FETCH_MY_ANNOUNCEMENTS_REQUEST,
  FETCH_MY_ANNOUNCEMENTS,
  FETCH_MY_ANNOUNCEMENTS_FAILED,
  CLEAR_ANNOUNCEMENTS,
  FETCH_MY_PROJECT_ANNOUNCEMENT_REQUEST,
  FETCH_MY_PROJECT_ANNOUNCEMENT,
  FETCH_MY_PROJECT_ANNOUNCEMENT_FAILED,
};

// Thunk Action Creator
export const fetchMyAnnouncements: ThunkActionCreator<Promise<void>> =
  (projectid?: string) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_MY_ANNOUNCEMENTS_REQUEST });

    let url = `${Config.API_SERVICE_URL}/api/announcements/me`;

    if (projectid) {
      url = url.concat(`?projectId=${projectid}`);
    }

    return axios
      .get(url, getHeaders())
      .then((response) => {
        // const basePrefix = `${Config.POG_BASE_URL}/${Config.POG_ENV}`;

        // //  Transform response
        // const updatedData = response.data.map((item: any) => ({
        //   ...item,
        //   allAttachments: item.allAttachments?.map((att: any) => ({
        //     ...att,
        //     URL: `${basePrefix}/${att.URL.replace(/^\/?/, "")}` 
        //   }))
        // }));
        dispatch({
          type: FETCH_MY_ANNOUNCEMENTS,
          payload: response.data
        });

        // dispatch({ type: FETCH_MY_ANNOUNCEMENTS, payload: updatedData });
      })
      .catch((error: Error) => {
        dispatch({ type: FETCH_MY_ANNOUNCEMENTS_FAILED });
      });
  };

export const clearAnnouncements = () => (dispatch: Dispatch) => {
  dispatch({ type: CLEAR_ANNOUNCEMENTS });
};

export const fetchMyProjectAnnouncements: ThunkActionCreator<Promise<void>> =
  (projectid: string) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_MY_PROJECT_ANNOUNCEMENT_REQUEST });
    let url = `${Config.API_SERVICE_URL}/api/announcements/project-announcement/${projectid}`;
    return axios
      .get(url, getHeaders())
      .then((response) => {
        dispatch({ type: FETCH_MY_PROJECT_ANNOUNCEMENT, payload: response.data });
      })
      .catch((error: Error) => {
        dispatch({ type: FETCH_MY_PROJECT_ANNOUNCEMENT_FAILED });
      });
  };
// Actions
const actions = {
  [FETCH_MY_ANNOUNCEMENTS_REQUEST]: (state: AnnouncementsState) => ({
    ...state,
    loading: true,
  }),
  [FETCH_MY_ANNOUNCEMENTS]: (state: AnnouncementsState, action: AnyAction): AnnouncementsState => ({
    ...state,
    loading: false,
    content: [...action.payload],
  }),
  [FETCH_MY_ANNOUNCEMENTS_FAILED]: (state: AnnouncementsState): AnnouncementsState => ({
    ...state,
    loading: false,
    hasError: true,
  }),
  [CREATE_ANNOUNCEMENT]: (state: AnnouncementsState, action: AnyAction): AnnouncementsState => ({
    ...state,
    loading: false,
    content: [...action.payload, ...(state.content || [])],
    hasError: false,
  }),
  [DELETE_ANNOUNCEMENT]: (state: AnnouncementsState, action: AnyAction): AnnouncementsState => ({
    ...state,
    loading: false,
    content: (state.content || []).filter((c) => c.id !== action.payload),
    hasError: false,
  }),

  [CLEAR_ANNOUNCEMENTS]: () => ({
    ...initialState,
  }),

  [FETCH_MY_PROJECT_ANNOUNCEMENT_REQUEST]: (state: AnnouncementsState) => ({
    ...state,
    loading: true,
  }),
  [FETCH_MY_PROJECT_ANNOUNCEMENT]: (
    state: AnnouncementsState,
    action: AnyAction
  ): AnnouncementsState => ({
    ...state,
    loading: false,
    content: [...action.payload],
  }),
  [FETCH_MY_PROJECT_ANNOUNCEMENT_FAILED]: (state: AnnouncementsState): AnnouncementsState => ({
    ...state,
    loading: false,
    hasError: true,
  }),
};

export interface AnnouncementsState {
  hasError?: boolean;
  errors?: string[];
  loading?: boolean;
  content?: Announcement[];
}

const initialState: AnnouncementsState = {
  loading: false,
  hasError: false,
  errors: [],
  content: [],
};

export default handleActions<AnnouncementsState, AnyAction>(actions, initialState);
